<template>
  <div class="agreement-component">
    <template v-for="(v, i) in vs">
      <div
        class="agreement-content"
        :key="i"
      >
        <div class="agreement-title"><b>{{v.versionName}}</b></div>
        <div
          class="agreement-item"
          v-html="v.versionContent.replace(/\$\$studentId/ig, studentId).replace(/\$\$number/ig, '').replace(/\$\$paymentSubject/ig, paymentSubject)"
        ></div>
      </div>
    </template>
    <div
      class="agreement-footer clearfix"
      @click="changeCheckbox"
    >
      <i
        class="checkbox"
        :class="{'checked': checked}"
      ></i>
      <span>{{TS('Agree_Text')}}</span>
    </div>
  </div>
</template>

<script>
import { I18n } from '../config'

export default {
  props: {
    versions: {
      type: Array,
      default: () => {
        return []
      }
    },
    channel: {
      type: String,
      default: ''
    },
    studentId: {
      type: [String, Number],
      default: ''
    },
    paymentSubject: {
      type: [String, Number],
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    i18n: {
      type: String,
      default: 'CN'
    },
    vs: {
      type: Array,
      default: () => {
        return []
      }
    },
    serialNumber: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {

    }
  },
  watch: {
    versions: {
      handler(val) {
        val && this.getVersionContent()
      },
      immediate: true
    },
    channel(val) {
      val && this.getVersionContent()
    }
  },
  methods: {
    TS(key) {
      return I18n(this.i18n, key)
    },
    getVersionContent() {
      this.loading = true
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/agreement/view/format/content',
        params: {
          channel: this.channel,
          version: this.versions.join() ? this.versions.join() : 'vt',
          serialNumber: this.serialNumber
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.vs.splice(0, this.vs.length)
          this.vs.push(...res.data.data)
        }
        this.loading = false
      })
    },
    changeCheckbox() {
      this.$emit('update:checked', !this.checked)
    }
  }
}
</script>

<style lang="less" scoped>
.agreement-component {
  border: 1px solid #e0e0e0;
  background-color: #fff;
  margin: 0 auto 15px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  .agreement-content {
    padding: 15px 20px 0;
    .agreement-title {
      margin-top: 8px;
      line-height: 18px;
      margin-bottom: 5px;
      font-size: 16px;
      color: #555;
    }
    .agreement-item {
      padding: 10px 20px;
      border: 1px solid #e0e0e0;
      height: 240px;
      font-size: 14px;
      overflow: auto;
      /deep/.order-wapper-container {
        p {
          margin-top: 8px;
        }
        .right {
          text-align: right;
        }
        .info {
          background-color: #fffce0;
          margin-bottom: 20px;
          padding: 20px;
        }
        h4 {
          margin-top: 20px;
        }
      }
    }
  }
  .agreement-footer {
    display: inline-block;
    padding: 20px;
    height: 60px;
    cursor: pointer;
    .checkbox {
      float: left;
      border: 1px solid #c7c7c7;
      border-radius: 3px;
      margin: 3px 5px 0 0;
      width: 13px;
      height: 13px;
      background-color: #ddd;
      &.checked {
        border-color: #f60;
        background: #f60 url("../../../../assets/images/order/bg.png") -42px -25px;
      }
    }
    span {
      float: left;
      font-size: 12px;
      color: #666;
      height: 20px;
      line-height: 20px;
    }
  }
}
</style>
